// Product catalog for MY BEEMA. Images sourced from Unsplash/Pexels per design guidelines.
export const PRODUCTS = [
  {
    id: "life",
    title: "Life Insurance",
    tagline: "Today for a Better Tomorrow",
    description: "Secure your family's future with comprehensive whole-life coverage.",
    image: "https://images.unsplash.com/photo-1624272864537-8ecc72b67958?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    extraLabel: "Desired Cover Amount (₹)",
    extraPlaceholder: "e.g. 50,00,000",
  },
  {
    id: "term",
    title: "Term Insurance",
    tagline: "Pure protection, maximum value",
    description: "High coverage at low premiums — protect what matters most.",
    image: "https://images.unsplash.com/photo-1519692933481-e162a57d6721?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    extraLabel: "Term Length (years)",
    extraPlaceholder: "e.g. 30",
  },
  {
    id: "health",
    title: "Health Insurance",
    tagline: "Wellness without worry",
    description: "Cashless hospitalisation, family floater & critical illness cover.",
    image: "https://images.pexels.com/photos/7578797/pexels-photo-7578797.jpeg?auto=compress&cs=tinysrgb&w=1200",
    extraLabel: "Family Size",
    extraPlaceholder: "e.g. Self + Spouse + 2 kids",
  },
  {
    id: "motor-car",
    title: "Motor Insurance (Car)",
    tagline: "Drive worry-free",
    description: "Comprehensive & third-party car insurance with instant renewal.",
    image: "https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    extraLabel: "Vehicle Registration Number",
    extraPlaceholder: "e.g. DL01AB1234",
  },
  {
    id: "motor-bike",
    title: "Motor Insurance (Bike)",
    tagline: "Ride protected, every kilometre",
    description: "Affordable two-wheeler policies with zero-depreciation add-on.",
    image: "https://images.pexels.com/photos/17095636/pexels-photo-17095636.png?auto=compress&cs=tinysrgb&w=1200",
    extraLabel: "Vehicle Registration Number",
    extraPlaceholder: "e.g. DL05CD5678",
  },
  {
    id: "travel",
    title: "Travel Insurance",
    tagline: "Explore. Without limits.",
    description: "Domestic & international travel cover for medical, baggage & delays.",
    image: "https://images.pexels.com/photos/1201995/pexels-photo-1201995.jpeg?auto=compress&cs=tinysrgb&w=1200",
    extraLabel: "Destination & Travel Dates",
    extraPlaceholder: "e.g. Singapore, 10–20 Mar",
  },
  {
    id: "home",
    title: "Home Insurance",
    tagline: "Protect every corner you call home",
    description: "Structure & contents cover against fire, theft & natural calamities.",
    image: "https://images.pexels.com/photos/323780/pexels-photo-323780.jpeg?auto=compress&cs=tinysrgb&w=1200",
    extraLabel: "Property Type",
    extraPlaceholder: "e.g. 2BHK owned apartment",
  },
  {
    id: "child-education",
    title: "Child Education Plan",
    tagline: "Their dreams. Your promise.",
    description: "Guaranteed maturity payouts aligned to your child's education goals.",
    image: "https://images.unsplash.com/photo-1560785496-3c9d27877182?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    extraLabel: "Child's Current Age",
    extraPlaceholder: "e.g. 6 years",
  },
  {
    id: "retirement",
    title: "Retirement / Pension Plan",
    tagline: "Independence, for life",
    description: "Build a steady income stream for your post-retirement years.",
    image: "https://images.pexels.com/photos/8871427/pexels-photo-8871427.jpeg?auto=compress&cs=tinysrgb&w=1200",
    extraLabel: "Target Retirement Age",
    extraPlaceholder: "e.g. 60",
  },
  {
    id: "business",
    title: "Business Insurance",
    tagline: "Cover every commercial risk",
    description: "Property, liability, marine & fire policies tailored to your business.",
    image: "https://images.pexels.com/photos/8463151/pexels-photo-8463151.jpeg?auto=compress&cs=tinysrgb&w=1200",
    extraLabel: "What type of business insurance",
    extraPlaceholder: "e.g. Fire, Marine, Liability, Group Health",
    extraHints: [
      "Fire & Property",
      "Marine / Transit",
      "Liability (Public / Product / Professional)",
      "Group Health / Group Personal Accident",
      "Workmen Compensation",
      "Burglary & Money in Transit",
      "Cyber Insurance",
      "Shopkeeper / SME Package",
      "Directors & Officers (D&O)",
      "Engineering / Contractor's All Risk",
    ],
  },
];

export const getProduct = (id) => PRODUCTS.find((p) => p.id === id);
